export const OPEN_MENU = "OPEN_MENU";
export const CLOSE_MENU = "OPEN_MENU";
export const SET_COMPONENT= 'SET_COMPONENT';
